
import { Badge } from "@/components/ui/badge";
import type { Owner } from "../types";

interface StatusColumnProps {
  row: Owner;
}

export const StatusColumn = ({ row }: StatusColumnProps) => {
  return (
    <Badge variant={row.is_blocked ? "destructive" : "outline"}>
      {row.is_blocked ? "Bloqué" : "Actif"}
    </Badge>
  );
};
